import { iconSizes } from '@hover/blueprint-theme/next';

var Icon = {
  baseStyle: {
    display: 'block'
  },
  defaultProps: {
    size: 'small'
  },
  sizes: iconSizes,
  variants: {}
};

var components = {
  Icon: Icon,
  isNext: true
};

export { components as c };
